import axios from 'axios'

let isSetup = false;

export default function() {
  // Prevent multiple interceptor registrations
  if (isSetup) return;
  isSetup = true;

  // Set default Accept header
  axios.defaults.headers.common["Accept"] = "application/json";

  // Use interceptor to read fresh CSRF token on each request
  // This prevents stale token issues with Turbolinks navigation
  axios.interceptors.request.use((config) => {
    const csrfToken = document.querySelector("meta[name=csrf-token]")?.content;
    if (csrfToken) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }
    return config;
  });
}